import { makeStyles, fade } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  padLeft: {
    paddingLeft: theme.spacing(1),
  },
  marginBot: {
    marginBottom: theme.spacing(1),
  },
  container: {
    padding: theme.spacing(1),
  },
  listItemRoot: {
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    borderBottom: `2px solid ${fade(theme.palette.action.disabledBackground, 0.05)}`,
  },
  listItemRootHeader: {
    borderBottom: 'none',
  },
  listItemHeader: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  listItemSecondary: {
    [theme.breakpoints.down('xs')]: {
      marginLeft: theme.spacing(-4.5),
      marginTop: theme.spacing(2),
    },
  },
  listItemActions: {
    [theme.breakpoints.down('xs')]: {
      top: 'inherit',
      bottom: theme.spacing(-3.5),
    },
  },
  greyIcon: {
    color: theme.colors.greyIcon,
    width: theme.spacing(2),
    height: theme.spacing(2),
  },
  orangeIcon: {
    color: theme.colors.orangeIcon,
    width: theme.spacing(2),
    height: theme.spacing(2),
  },
  redIcon: {
    color: theme.colors.redIcon,
    width: theme.spacing(2),
    height: theme.spacing(2),
  },
  avatar: {
    marginRight: theme.spacing(1),
    alignSelf: 'flex-start',
    backgroundColor: theme.colors.transparent,
    color: theme.palette.text.primary,
  },
  datesText: {
    fontSize: 13,
  },
  issueBtnRoot: {
    backgroundColor: theme.palette.action.disabledBackground,
    pointerEvents: 'none',
    width: 65,
    height: 65,
    marginLeft: 5,
  },
  issueBtnLabel: {
    flexDirection: 'column',
    display: 'flex',
    fontSize: 12,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  updatedCol: {
    width: 110,
    [theme.breakpoints.down('xs')]: {
      width: 80,
    },
  },
  colTitle: {
    fontSize: 12,
    fontWeight: '500',
  },

  msgBtnRoot: {
    border: `1px solid black`,
    minWidth: 'auto',
    borderRadius: 50,
    width: 50,
    height: 50,
    marginLeft: 5,
    boxShadow: '0 2px 2px rgba(0,0,0,0.2)',
  },
  msgBtnLabel: {
    flexDirection: 'column',
    display: 'flex',
    fontSize: 12,
  },

  createButton: {
    marginRight: theme.spacing(1),
    marginLeft: 'auto',
  },
}));

export default useStyles;
